import React, { useState } from "react";
import {
  Box,
  Button,
  Menu,
  MenuItem,
  Avatar,
  Typography,
  Divider,
  IconButton,
} from "@mui/material";
import {
  AccountCircle,
  Person,
  Logout,
  Settings,
  AdminPanelSettings,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const UserMenu = () => {
  const { user, logout, isAuthenticated, isAdmin } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLoginClick = () => {
    navigate("/login");
  };

  const handleSignupClick = () => {
    navigate("/signup");
  };

  const handleLogout = () => {
    handleMenuClose();
    logout();
  };

  if (!isAuthenticated) {
    return (
      <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        <Button
          variant="text"
          color="inherit"
          onClick={handleLoginClick}
          sx={{ textTransform: "none" }}
        >
          Sign In
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleSignupClick}
          sx={{ textTransform: "none" }}
        >
          Sign Up
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <IconButton
        onClick={handleMenuClick}
        sx={{
          color: "inherit",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.1)",
          },
        }}
      >
        {user?.avatar ? (
          <Avatar
            src={user.avatar}
            alt={user.username}
            sx={{ width: 32, height: 32 }}
          />
        ) : (
          <AccountCircle sx={{ fontSize: 32 }} />
        )}
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            mt: 1,
            minWidth: 200,
            boxShadow: 3,
          },
        }}
      >
        <MenuItem sx={{ py: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            {user?.avatar ? (
              <Avatar
                src={user.avatar}
                alt={user.username}
                sx={{ width: 40, height: 40 }}
              />
            ) : (
              <Avatar sx={{ width: 40, height: 40 }}>
                <Person />
              </Avatar>
            )}
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                {user?.username || user?.email}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {user?.email}
              </Typography>
              {isAdmin && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    mt: 0.5,
                  }}
                >
                  <AdminPanelSettings
                    sx={{ fontSize: 16, color: "warning.main" }}
                  />
                  <Typography
                    variant="caption"
                    color="warning.main"
                    sx={{ fontWeight: 600 }}
                  >
                    ADMIN
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
        </MenuItem>

        <Divider />

        <MenuItem
          onClick={() => {
            handleMenuClose();
            navigate("/app/profile");
          }}
        >
          <Person sx={{ mr: 2 }} />
          Profile
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleMenuClose();
            navigate("/app/settings");
          }}
        >
          <Settings sx={{ mr: 2 }} />
          Settings
        </MenuItem>

        <Divider />

        <MenuItem onClick={handleLogout}>
          <Logout sx={{ mr: 2 }} />
          Sign Out
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default UserMenu;
